import { Form } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import { FormItem } from 'components/UIComponents/FormStyles/index'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import AlarmIcon from 'components/icons/AlarmIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import {
  BreakDiv,
  FooterFlex,
  HeaderFlex,
  IconWrapper,
  Inputdiv,
  LabelDiv,
  SessionFlex,
  StartSpan,
  TimeDiv,
  TimeFlex,
  TimeInfoDiv,
  TimeStyles,
  TotalTimeDiv,
} from 'modules/Exp-Candidates/ViewDrive/DriveTimeDrawer/style'
import { getDriveTime } from 'modules/Exp-Candidates/utils'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import SuccessMessage from 'utils/SuccessMessage'

const DriveTimeDrawer = ({
  driveTime,
  setDriveTime,
  driveId,
  addTimeBreak,
  driveData,
  getIndidualDriveData,
}) => {
  const [form] = Form.useForm()
  const [formData, setFormData] = useState([])
  const [loading, setLoading] = useState(false)

  const addToForm = () => {
    setFormData([
      ...formData,
      {
        type: '',
        start: '',
        end: '',
        time: '',
      },
    ])
  }

  const onChangeType = (e, index) => {
    let breaks = form.getFieldsValue()?.breaks
    breaks[index].type = e.target.value
    setFormData(breaks)
  }

  const onChangeTime = (_, time, index) => {
    let breaks = form.getFieldsValue()?.breaks
    breaks[index].start = time[0]
    breaks[index].end = time[1]
    breaks[index].time = time
    setFormData(breaks)
  }

  const onCancel = () => {
    setDriveTime(false)
    form.resetFields()
    setFormData([])
  }

  const addBreakTime = async values => {
    if (Object.keys(values).includes('breaks')) {
      setLoading(true)
      let response = await addTimeBreak(driveId, values?.breaks ? values : {})
      if (response?.status >= 200 && response?.status <= 300) {
        SuccessMessage('Drive break time created successfully!')
        getIndidualDriveData(driveId)
        setDriveTime(false)
        setLoading(false)
        setFormData([])
        form.resetFields()
      } else {
        setLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    }
  }

  useEffect(() => {
    if (driveData?.breaks) {
      let breaks = driveData?.breaks
      let updatedFormData = breaks?.map((data, index) => {
        return {
          type: data?.type,
          start: data?.start,
          end: data?.end,
          time: [moment(data?.start, 'HH:mm'), moment(data?.end, 'HH:mm')],
        }
      })
      setFormData(updatedFormData)
    }
  }, [driveData])

  useEffect(() => {
    form.setFieldsValue({
      breaks: formData,
    })
  }, [formData])

  useEffect(() => {
    getIndidualDriveData(driveId)
  }, [])

  const content = () => {
    return (
      <Form form={form} name={'breakform'} onFinish={addBreakTime}>
        <HeaderFlex spaceBetween>
          <TotalTimeDiv>
            Total Time <StartSpan>*</StartSpan>
          </TotalTimeDiv>
          <TimeDiv>(GMT+05:30) Asia/ Kolkata</TimeDiv>
        </HeaderFlex>
        <TimeFlex spaceBetween centerVertically>
          <TimeInfoDiv>
            {getDriveTime({
              startTime: driveData?.startTime,
              endTime: driveData?.endTime,
            })}
          </TimeInfoDiv>
          <div>
            <AlarmIcon />
          </div>
        </TimeFlex>

        <Fragment>
          <BreakDiv>Breaks</BreakDiv>

          <Form.List name="breaks">
            {(fields, { add, remove }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Inputdiv key={key + name}>
                      <SessionFlex row center>
                        <FormItem
                          name={[name, 'type']}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter a type!',
                            },
                          ]}
                        >
                          <Flex column>
                            <TotalTimeDiv height>
                              Type<StartSpan>*</StartSpan>
                            </TotalTimeDiv>
                            <LabelDiv>
                              <Input
                                width="100%"
                                placeholder="Break"
                                value={formData[name]?.type}
                                onChange={e => onChangeType(e, name)}
                              />
                            </LabelDiv>
                          </Flex>
                        </FormItem>
                        <FormItem name={[name, 'start']} />
                        <FormItem name={[name, 'end']} />
                        <FormItem
                          name={[name, 'time']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select the time range!',
                            },
                          ]}
                        >
                          <Flex column>
                            <TotalTimeDiv>Pick Time</TotalTimeDiv>
                            <TimeStyles
                              suffixIcon={<AlarmIcon />}
                              width="100%"
                              format="HH:mm"
                              placeholder={['StartTime', 'EndTime']}
                              onChange={(_, time) =>
                                onChangeTime(_, time, name)
                              }
                              defaultValue={
                                formData[name]?.time[0]
                                  ? [
                                      moment(formData[name]?.time[0], 'HH:mm'),
                                      moment(formData[name]?.time[1], 'HH:mm'),
                                    ]
                                  : []
                              }
                              value={
                                formData[name]?.time[0]
                                  ? [
                                      moment(formData[name]?.time[0], 'HH:mm'),
                                      moment(formData[name]?.time[1], 'HH:mm'),
                                    ]
                                  : []
                              }
                            />
                          </Flex>
                        </FormItem>
                        <Flex>
                          <IconWrapper onClick={() => remove(name)}>
                            <DeleteIcon />
                          </IconWrapper>
                        </Flex>
                      </SessionFlex>
                    </Inputdiv>
                  ))}
                  <Form.Item>
                    <Button.Secondary
                      text={'Add Time Breakdown'}
                      width="100%"
                      icon={<PlusWhiteIcon />}
                      dashed="true"
                      onClick={() => {
                        add()
                        addToForm()
                      }}
                    />
                  </Form.Item>
                </>
              )
            }}
          </Form.List>
        </Fragment>
      </Form>
    )
  }
  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="121px"
          text="Cancel"
          onClick={() => onCancel()}
        />
        <Button.Primary
          text="Save"
          width="91px"
          onClick={addBreakTime}
          form={'breakform'}
          htmlType="submit"
          loading={loading}
        />
      </FooterFlex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Drive Time Settings'}
      placement="right"
      visible={driveTime}
      content={content()}
      footer={footer()}
      onClose={() => onCancel()}
      closable
    />
  )
}

export default DriveTimeDrawer
